import React, {useEffect, useState} from 'react'
import VideoCard from "./VideoCard"
import axios from 'axios'

const VideoList = ({videos, isBougth}) => {
  const [favouritesVideos, setFavoritesVideos] = useState(JSON.parse(localStorage.getItem("favouritesVideos")) ?? [])

  useEffect(() => {
    localStorage.setItem('favouritesVideos', JSON.stringify(favouritesVideos))
  }, [favouritesVideos])
  return (
	 <div>
      {
        videos.map(video => (
          <VideoCard video={video} setFavoritesVideos={setFavoritesVideos} favouritesVideos={favouritesVideos} isBougth={isBougth}/>
        ))
      }
   </div>
  )
}

export default VideoList
